import React from 'react';

import Button from '@atlaskit/button/default/button';

const TokenButtonCodeBlock = `import { B300, B400, B500, N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// default state
color: token('color.text.inverse', N0),
background: token('color.background.selected.bold', B400),

// hovered state
&:hover {
  background: token('color.background.selected.bold.hovered', B300),
}

// pressed state
&:active {
  background: token('color.background.selected.bold.pressed', B500),
}`;

const TokenButton = (): React.JSX.Element => {
	return <Button appearance="primary">Default button</Button>;
};

const _default_1: {
	example: () => React.JSX.Element;
	code: string;
} = { example: TokenButton, code: TokenButtonCodeBlock };
export default _default_1;
